import axios from 'axios'

const server = 'https://wmsapp.vallysys.com.br:9000'

const REQUEST = {}

REQUEST.post = (url='', body={}, headers={}) => {
    return axios.post(server + url, body, headers)
}

export default REQUEST